import React, { Component } from 'react'
import Footer from '../../components/common/Footer';
import Header from '../../components/admin/common/Header';
import store from '../../store/index';
import { setLoading } from '../../store/reducers/global-reducer';
import axios from 'axios';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import SpinnerLoader from '../../components/common/SpinnerLoader';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import arrow_back from '../../assets/icons/arrow-back.svg'

class AdminSellerEarnings extends Component {
    constructor(props) {
        super(props)
        this.authInfo = store.getState().auth.authInfo;
        const { dispatch } = props;
        this.dispatch = dispatch;
        this.state = {
            sellersData: [],
            selectedSeller: null,
            sellerTransactions: [],
            totalStats: {
                totalSellers: 0,
                totalRevenue: 0,
                totalPlatformFees: 0,
                totalSellerEarnings: 0,
                totalFxMarkup: 0,
                totalAdRevenue: 0,
            }
        }
        toast.configure();

        // Main sellers table columns
        this.sellersTable_columns = [
            {
                name: 'SELLER INFO',
                cell: (row) => (
                    <div>
                        <p className="mb-0 fw-bold">{row.seller?.name || row.seller?.firstName || 'N/A'}</p>
                        <small className="text-muted">{row.seller?.email || 'N/A'}</small>
                    </div>
                ),
                sortable: true,
                width: '200px'
            },
            {
                name: 'TOTAL EARNINGS',
                selector: (row) => `$${parseFloat(row.totalEarnings || 0).toFixed(2)}`,
                sortable: true,
                width: '130px',
                style: {
                    color: '#28a745',
                    fontWeight: 'bold'
                }
            },
            {
                name: 'PLATFORM FEES',
                selector: (row) => `$${parseFloat(row.totalPlatformFees || 0).toFixed(2)}`,
                sortable: true,
                width: '130px',
                style: {
                    color: '#dc3545',
                    fontWeight: 'bold'
                }
            },
            {
                name: 'FX MARKUP',
                selector: (row) => `$${parseFloat(row.totalFxMarkup || 0).toFixed(2)}`,
                sortable: true,
                width: '120px',
                style: {
                    color: '#6f42c1',
                    fontWeight: 'bold'
                }
            },
            {
                name: 'AD REVENUE',
                cell: (row) => (
                    <div>
                        <div style={{ color: '#fd7e14', fontWeight: 'bold' }}>
                            ${parseFloat(row.totalAdRevenue || 0).toFixed(2)}
                        </div>
                        {row.adSubscriptionCount > 0 && (
                            <small className="text-muted">{row.adSubscriptionCount} sub(s)</small>
                        )}
                    </div>
                ),
                selector: (row) => Number(row.totalAdRevenue || 0),
                sortable: true,
                width: '130px',
            },
            {
                name: 'TRANSACTIONS',
                selector: (row) => row.totalTransactions || 0,
                sortable: true,
                width: '120px'
            },
            {
                name: 'PRODUCTS SOLD',
                selector: (row) => row.totalProductsSold || 0,
                sortable: true,
                width: '120px'
            },
            {
                name: 'AVG FEE %',
                selector: (row) => `${parseFloat(row.averageFeePercentage || 0).toFixed(1)}%`,
                sortable: true,
                width: '100px'
            },
            {
                name: 'LAST TRANSACTION',
                selector: (row) => row.lastTransactionDate ? 
                    new Date(row.lastTransactionDate).toLocaleDateString() : 'Never',
                sortable: true,
                width: '140px'
            },
            {
                name: 'ACTIONS',
                cell: (row) => (
                    <button
                        className="btn btn-sm btn-primary text-nowrap"
                        onClick={() => this.viewSellerDetails(row)}
                    >
                        Details
                    </button>
                ),
                sortable: false
            }
        ];

        // Seller transactions table columns
        this.transactionTable_columns = [
            {
                name: 'DATE',
                selector: (row) => new Date(row.createdAt).toLocaleDateString(),
                sortable: true,
                width: '100px'
            },
            {
                name: 'INVOICE',
                selector: (row) => row.invoiceNo || 'N/A',
                sortable: true,
                width: '120px'
            },
            {
                name: 'CUSTOMER',
                selector: (row) => row.customerName || 'N/A',
                sortable: true,
                width: '150px'
            },
            {
                name: 'PRODUCTS',
                cell: (row) => (
                    <div>
                        <small>{row.products?.length || 0} item(s)</small>
                    </div>
                ),
                sortable: false,
                width: '80px'
            },
            {
                name: 'TOTAL AMOUNT',
                selector: (row) => `$${parseFloat(row.originalAmount || 0).toFixed(2)}`,
                sortable: true,
                width: '120px'
            },
            {
                name: 'PLATFORM FEE',
                selector: (row) => `$${parseFloat(row.platformFee || 0).toFixed(2)}`,
                sortable: true,
                width: '120px',
                style: { color: '#dc3545' }
            },
            {
                name: 'SELLER PAYOUT',
                selector: (row) => `$${parseFloat(row.sellerPayout || 0).toFixed(2)}`,
                sortable: true,
                width: '120px',
                style: { color: '#28a745', fontWeight: 'bold' }
            }
        ];
    }

    componentDidMount() {
        this.getAllSellersEarnings();
    }

    // Get all sellers earnings data
    getAllSellersEarnings = async () => {
        try {
            this.dispatch(setLoading({ loading: true }));
            const url = 'admin/getAllSellersEarnings';
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${this.authInfo.token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (response.data.status === true) {
                this.setState({ 
                    sellersData: response.data.data.sellers || [],
                    totalStats: response.data.data.totalStats || this.state.totalStats
                });
            }
        } catch (error) {
            console.error('Error fetching sellers earnings:', error);
            toast.error('Failed to load sellers earnings data');
        } finally {
            this.dispatch(setLoading({ loading: false }));
        }
    }

    // View individual seller details
    viewSellerDetails = async (sellerData) => {
        try {
            this.dispatch(setLoading({ loading: true }));
            const url = 'admin/getSellerTransactions';
            const response = await axios.get(url, {
                params: {
                    sellerId: sellerData.sellerId
                },
                headers: {
                    'Authorization': `Bearer ${this.authInfo.token}`,
                    'Content-Type': 'application/json',
                }
            });

            if (response.data.status === true) {
                this.setState({ 
                    selectedSeller: sellerData,
                    sellerTransactions: response.data.data || []
                });
            }
        } catch (error) {
            console.error('Error fetching seller transactions:', error);
            toast.error('Failed to load seller transaction details');
        } finally {
            this.dispatch(setLoading({ loading: false }));
        }
    }

    // Close seller details modal
    closeSellerDetails = () => {
        this.setState({
            selectedSeller: null,
            sellerTransactions: []
        });
    }

    render() {
        const { loading } = store.getState().global;
        const { sellersData, selectedSeller, sellerTransactions, totalStats } = this.state;

        return (
            <React.Fragment>
                {loading === true ? <SpinnerLoader /> : ''}
                <div className="admin_body">
                    <Header />
                    <div className="inr_top_page_title">
                        <h2>Seller Earnings Management</h2>
                    </div>
                    <Helmet>
                        <title>{"Admin - Seller Earnings - Pay Earth"}</title>
                    </Helmet>
                    <div className="seller_dash_wrap pt-2 pb-5">
                        <div className="container">
                            <div className="bg-white rounded-3 pt-3 pb-5">
                                <div className="dash_inner_wrap pb-2">
                                    <div className="col-md-12 pt-2 pb-3 d-flex justify-content-between align-items-center">
                                        <div className="dash_title">All Sellers Earnings Overview</div>
                                        <button
                                            type="button"
                                            className="btn custom_btn btn_yellow rounded-pill px-4 py-1 ms-4 d-flex align-items-center"
                                            onClick={() => window.history.back()}
                                            style={{ height: "40px", whiteSpace: "nowrap", gap: "6px" }}
                                            >
                                            <img src={arrow_back} alt="back" style={{ height: "18px" }} />
                                            Back
                                            </button>
                                    </div>
                                </div>

                                {/* Platform Stats Cards */}
                                <div className="row g-3 mb-4">
                                    <div className="col-lg col-md-6">
                                        <div className="card bg-info text-white h-100">
                                            <div className="card-body">
                                                <h5 className="card-title">Total Sellers</h5>
                                                <h3 className="card-text">{totalStats.totalSellers}</h3>
                                                <small>Active sellers</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg col-md-6">
                                        <div className="card bg-primary text-white h-100">
                                            <div className="card-body">
                                                <h5 className="card-title">Total Revenue</h5>
                                                <h3 className="card-text">${parseFloat(totalStats.totalRevenue || 0).toFixed(2)}</h3>
                                                <small>Platform + Sellers</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg col-md-6">
                                        <div className="card bg-success text-white h-100">
                                            <div className="card-body">
                                                <h5 className="card-title">Platform Fees</h5>
                                                <h3 className="card-text">${parseFloat(totalStats.totalPlatformFees || 0).toFixed(2)}</h3>
                                                <small>Our earnings</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg col-md-6">
                                        <div className="card text-white h-100" style={{ background: '#6f42c1' }}>
                                            <div className="card-body">
                                                <h5 className="card-title">FX Markup</h5>
                                                <h3 className="card-text">${parseFloat(totalStats.totalFxMarkup || 0).toFixed(2)}</h3>
                                                <small>Hidden currency spread</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg col-md-6">
                                        <div className="card text-white h-100" style={{ background: '#fd7e14' }}>
                                            <div className="card-body">
                                                <h5 className="card-title">Ad Revenue</h5>
                                                <h3 className="card-text">${parseFloat(totalStats.totalAdRevenue || 0).toFixed(2)}</h3>
                                                <small>Subscriptions paid by sellers</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg col-md-6">
                                        <div className="card bg-warning text-white h-100">
                                            <div className="card-body">
                                                <h5 className="card-title">Seller Earnings</h5>
                                                <h3 className="card-text">${parseFloat(totalStats.totalSellerEarnings || 0).toFixed(2)}</h3>
                                                <small>Paid to sellers</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Sellers Data Table */}
                                <div className="orders_table">
                                    <h5 className="mb-3">All Sellers Performance</h5>
                                    <DataTableExtensions
                                        columns={this.sellersTable_columns}
                                        data={sellersData}
                                        export={true}
                                        exportHeaders={true}
                                        fileName="sellers-earnings-report"
                                    >
                                        <DataTable
                                            pagination
                                            noHeader
                                            highlightOnHover
                                            defaultSortField="totalEarnings"
                                            defaultSortAsc={false}
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 20, 50]}
                                        />
                                    </DataTableExtensions>
                                </div>

                                {/* Seller Details Modal */}
                                {selectedSeller && (
                                    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                                        <div className="modal-dialog modal-xl">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">
                                                        Seller Details: {selectedSeller.seller?.name || selectedSeller.seller?.firstName || 'Unknown'}
                                                    </h5>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        onClick={this.closeSellerDetails}
                                                    ></button>
                                                </div>
                                                <div className="modal-body">
                                                    {/* Seller Stats */}
                                                    <div className="row g-3 mb-4">
                                                        <div className="col-lg col-md-6">
                                                            <div className="card bg-light h-100">
                                                                <div className="card-body text-center">
                                                                    <h6>Total Earnings</h6>
                                                                    <h4 className="text-success">${parseFloat(selectedSeller.totalEarnings || 0).toFixed(2)}</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg col-md-6">
                                                            <div className="card bg-light h-100">
                                                                <div className="card-body text-center">
                                                                    <h6>Platform Fees</h6>
                                                                    <h4 className="text-danger">${parseFloat(selectedSeller.totalPlatformFees || 0).toFixed(2)}</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg col-md-6">
                                                            <div className="card bg-light h-100">
                                                                <div className="card-body text-center">
                                                                    <h6>FX Markup</h6>
                                                                    <h4 style={{ color: '#6f42c1' }}>${parseFloat(selectedSeller.totalFxMarkup || 0).toFixed(2)}</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg col-md-6">
                                                            <div className="card bg-light h-100">
                                                                <div className="card-body text-center">
                                                                    <h6>Ad Revenue</h6>
                                                                    <h4 style={{ color: '#fd7e14' }}>${parseFloat(selectedSeller.totalAdRevenue || 0).toFixed(2)}</h4>
                                                                    {selectedSeller.adSubscriptionCount > 0 && (
                                                                        <small className="text-muted d-block">{selectedSeller.adSubscriptionCount} subscription(s)</small>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg col-md-6">
                                                            <div className="card bg-light h-100">
                                                                <div className="card-body text-center">
                                                                    <h6>Transactions</h6>
                                                                    <h4 className="text-primary">{selectedSeller.totalTransactions || 0}</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg col-md-6">
                                                            <div className="card bg-light h-100">
                                                                <div className="card-body text-center">
                                                                    <h6>Avg Fee %</h6>
                                                                    <h4 className="text-info">{parseFloat(selectedSeller.averageFeePercentage || 0).toFixed(1)}%</h4>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Transactions Table */}
                                                    <h6>Recent Transactions</h6>
                                                    <DataTable
                                                        columns={this.transactionTable_columns}
                                                        data={sellerTransactions}
                                                        pagination
                                                        noHeader
                                                        highlightOnHover
                                                        defaultSortField="createdAt"
                                                        defaultSortAsc={false}
                                                        paginationPerPage={5}
                                                        paginationRowsPerPageOptions={[5, 10, 20]}
                                                        dense
                                                    />
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={this.closeSellerDetails}
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </React.Fragment>
        )
    }
}

export default connect(setLoading)(AdminSellerEarnings);